import { ProductTabUsageModel } from 'autogen/swagger/all';
import React from 'react';
import styled from 'styled-components';
import BlockList from '../blockList';
import HorizontalVideoArticleCard from './HorizontalVideoArticleCard';

const UsageWrapper = styled.div`
    display: grid;
    grid-template-columns: auto;
    row-gap: 16px;
`;

export default function Usage(props: ProductTabUsageModel) {
    const {
        video,
        blockList: { blocks }
    } = props;

    return (
        <UsageWrapper>
            {video ? <HorizontalVideoArticleCard videoModel={video} /> : null}
            <BlockList blocks={blocks} />
        </UsageWrapper>
    );
}
